import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=435f4876&scoped=true&"
import script from "./DocumentCard.vue?vue&type=script&lang=js&"
export * from "./DocumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f4876",
  null
  
)

export default component.exports